import { z } from "zod";
import { getIdSchema, ID, makeIdGenerator } from "../utils";
import { accountIdSchema } from "./accountSchema";
import { deviceIdSchema } from "./deviceSchema";
import { loadIdSchema } from "./loadSchema";

export const scaleIdPrefix = "sca_";
export type ScaleId = ID<typeof scaleIdPrefix>;
export const generateScaleId = makeIdGenerator(scaleIdPrefix);
export const scaleIdSchema = getIdSchema(scaleIdPrefix, "ScaleId");

export const scaleSchema = z
  .object({
    id: scaleIdSchema,
    accountId: accountIdSchema,
    loadId: loadIdSchema.nullable(),
    deviceId: deviceIdSchema,
    channel: z.number().int().min(0),
    name: z.string(),
    type: z.enum(["wifihivescale", "fatbees"]),
    firstReport: z.coerce.date().nullable(),
    lastReport: z.coerce.date().nullable(),
    location: z
      .object({
        name: z.string(),
        since: z.coerce.date(),
      })
      .optional(),
  })
  .meta({ id: "Scale" });

export const otaScaleSchema = scaleSchema
  .omit({
    location: true,
  })
  .meta({ id: "OtaScale" });

export type Scale = z.infer<typeof scaleSchema>;
